import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"

interface Props {
  label: string
  description: string
  values?: object
}

const Field: React.FC<Props> = ({label, description, values}) => (
  <li>
    <Body small weight="semibold" display="inline-block">
      <FormattedMessage id={label} />
    </Body>
    &nbsp;-&nbsp;
    <FormattedMessage id={description} values={values} />
  </li>
)

export default Field
